import * as React from 'react';
import type { SVGProps } from 'react';

const IconDeepResearch = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
      <path
        d="M7.858 15.95a.552.552 0 0 0 .55-.549 6.74 6.74 0 0 1 6.74-6.74.552.552 0 0 0 .55-.548.57.57 0 0 0-.55-.549c-3.71 0-6.74-3.03-6.74-6.74a.552.552 0 0 0-.55-.548.57.57 0 0 0-.548.549 6.74 6.74 0 0 1-6.742 6.74.552.552 0 0 0-.548.548.57.57 0 0 0 .548.549 6.74 6.74 0 0 1 6.742 6.74c0 .313.261.548.548.548Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default IconDeepResearch;
